import React, { useState } from 'react'

import { IMAGE_RESTORE_STATUS } from './constants'
import RestoreBanner from './RestoreBanner'
import RestoreControl from './RestoreControl'
import useImageRestore from './useImageRestore'

const { FINISHED, CLOSED } = IMAGE_RESTORE_STATUS

// Mounted only when the feature flag is on (gated in Listing) so the status
// fetch never fires for sellers without the flag.
function ImageRestore() {
  const {
    status, isInitialized, isTriggering, triggerRestore, closeSection,
  } = useImageRestore()
  const [collapsed, setCollapsed] = useState(false)

  if (!isInitialized || status === CLOSED) return null

  // Finished is the only state whose close hits the backend (marks `closed`).
  if (status === FINISHED) {
    return <RestoreBanner status={FINISHED} onClose={closeSection} />
  }

  // idle / pending: the close is a client-side collapse to the top-right control.
  if (collapsed) {
    return <RestoreControl status={status} onExpand={() => setCollapsed(false)} />
  }

  return (
    <RestoreBanner
      status={status}
      isTriggering={isTriggering}
      onRestore={triggerRestore}
      onClose={() => setCollapsed(true)}
    />
  )
}

export default ImageRestore
